document.addEventListener("DOMContentLoaded", function () {
  // Oculta el banner de cookies de Shopify
  var cookieBanner = document.querySelector("#shopify-pc__banner");
  if (cookieBanner) {
    cookieBanner.style.display = "none";
    cookieBanner.style.visibility = "hidden";
  }

  var consentDone = false;

  function acceptCookiesShopify() {
    if (consentDone) return;

    if (window.Shopify && Shopify.customerPrivacy) {
      Shopify.customerPrivacy.setTrackingConsent({
        analytics: true,
        marketing: true,
        preferences: true,
        sale_of_data: true
      }, function () {
        consentDone = true;
        console.log("[OK] Granular cookies accepted via Shopify API!");
      });

    } else if (window.Shopify && typeof Shopify.loadFeatures === "function") {
      // La API no esta cargada: la cargamos nosotros y volvemos a intentar
      console.log("[...] Cargando consent-tracking-api...");
      Shopify.loadFeatures(
        [{ name: "consent-tracking-api", version: "0.1" }],
        function (error) {
          if (error) {
            console.log("[ERROR] consent-tracking-api", error);
            return;
          }
          acceptCookiesShopify();
        }
      );

    } else {
      // Shopify todavia no ha inicializado: reintento breve
      console.log("[...] Shopify no listo, reintentando...");
      setTimeout(acceptCookiesShopify, 500);
    }
  }

  acceptCookiesShopify();

  // Portada: el titulo de Edicion limitada lleva tilde (en el tema se guarda sin tilde)
  document.querySelectorAll("main strong").forEach(function (strong) {
    if (strong.textContent.trim() === "EDICION LIMITADA") strong.textContent = "EDICIÓN LIMITADA";
  });
});

// Guia de tallas: junto a la etiqueta "Talla", a la derecha, en la misma línea.
(function () {
  var style = document.createElement("style");
  style.textContent = ".om-gt__fs .om-gt__open--abs{top:-21px !important;}";
  document.head.appendChild(style);
})();

// Colores con foto: cada color se muestra como miniatura con la foto de la variante.
// El selector se vuelve a dibujar al elegir variante: las fotos se aplican en el mismo
// ciclo de render (MutationObserver), antes de pintar, para que no parpadee el texto.
// Si una variante no tiene foto, se mantiene el boton de texto.
(function () {
  var productMatch = window.location.pathname.match(/^\/products\/[^/]+/);
  if (!productMatch) return;

  var style = document.createElement("style");
  style.textContent =
    ".color-photo-swatch{display:inline-block !important;width:64px !important;min-width:0 !important;padding:0 !important;border:0 !important;background:none !important;font-size:0 !important;line-height:0 !important;vertical-align:top;cursor:pointer;}" +
    ".color-photo-swatch img{display:block;width:64px;height:85px;object-fit:cover;border:1px solid rgba(0,0,0,.15);}" +
    "input:checked + .color-photo-swatch img{outline:2px solid rgb(var(--color-foreground));outline-offset:2px;}";
  document.head.appendChild(style);

  var imageByValue = null;
  var loading = false;

  function isColorFieldset(fs) {
    var legend = fs.querySelector("legend");
    return legend && /^\s*Color/i.test(legend.textContent);
  }

  function decorate() {
    if (!imageByValue) return;
    Array.prototype.filter.call(
      document.querySelectorAll("fieldset.product-form__input"),
      isColorFieldset
    ).forEach(function (fs) {
      fs.querySelectorAll("input[type=radio]").forEach(function (input) {
        var label = fs.querySelector('label[for="' + input.id + '"]');
        var src = imageByValue[input.value];
        if (!label || !src || label.querySelector("img")) return;

        var img = document.createElement("img");
        img.src = src.replace(/(\.(jpg|jpeg|png|webp))(\?.*)?$/i, "_160x213$1$3");
        img.alt = input.value;
        img.width = 64;
        img.height = 85;
        label.classList.add("color-photo-swatch");
        label.insertBefore(img, label.firstChild);
      });
    });
  }

  function load() {
    if (imageByValue || loading) return;
    loading = true;
    fetch(productMatch[0] + ".js")
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var colorIndex = -1;
        product.options.forEach(function (option, i) {
          var name = typeof option === "string" ? option : option.name;
          if (/^\s*Color/i.test(name)) colorIndex = i;
        });
        if (colorIndex < 0) return;

        var map = {};
        product.variants.forEach(function (variant) {
          var value = variant.options[colorIndex];
          var src = variant.featured_image && variant.featured_image.src;
          if (value && src && !map[value]) map[value] = src;
        });
        imageByValue = map;
        decorate();
      })
      .catch(function (err) { console.log("[ERROR] colores con foto", err); });
  }

  new MutationObserver(function () {
    if (imageByValue) decorate();
    else load();
  }).observe(document.body, { childList: true, subtree: true });

  load();
})();

// Colecciones (movil): menos hueco entre el banner y el texto, la imagen ocupa todo
// el ancho de la pantalla (de borde a borde) y no queda la linea blanca fina de arriba.
(function () {
  var style = document.createElement("style");
  style.textContent =
    "@media (max-width: 749px){" +
    " .collection-hero__text-wrapper{ padding-top: 16px !important; }" +
    " .collection-hero__image-container{ width:100vw !important; max-width:none !important; margin-left:calc(50% - 50vw) !important; margin-right:0 !important; margin-top:0 !important; border:0 !important; overflow:hidden; }" +
    " .collection-hero__image-container img{ width:100% !important; height:100% !important; object-fit:cover !important; display:block; margin-top:0 !important; border:0 !important; }" +
    "}";
  document.head.appendChild(style);
})();